module.exports = "\n<ngx-spinner class=\"myspiner\"></ngx-spinner>\n<!-- <app-navbar></app-navbar>   -->\n<router-outlet></router-outlet> \n "